export const MISC_CATEGORY = 'online_store_theme_asset_misc_category';
export const PAGE_SIZE = 13;
